import { ReactElement } from 'react';
import { BatchCollect } from 'types/batch-collect';

export enum DashboardCardType {
  WaitingAttendance = 'WAITING_ATTENDANCE',
  ReturnRequestInProgress = 'RETURN_REQUEST_IN_PROGRESS',
  WaitingCustomerPickUp = 'WAITING_CUSTOMER_PICK_UP',
  DeliveryFailure = 'DELIVERY_FAILURE',
  OnCarriage = 'ON_CARRIAGE',
  DeliveryFailedQuestion = 'DELIVERY_FAILED_QUESTION',
}

export type CardInfoDisplay = {
  title: string;
  buttonLabel: string;
  bgIcon: ReactElement;
  navigatePath: string;
  tooltipMessage?: string;
};

export type DashboardCard = {
  alert: boolean;
  quantity: number;
  type: DashboardCardType;
};

export type DashboardSummary = {
  entries: DashboardCard[];
  lastBatchCollect: BatchCollect;
};
